import { Component } from '@angular/core';

@Component({
  selector: 'csgofast-possible-items-list-mock',
  templateUrl: './possible-items-list.component.mock.html',
  styleUrls: ['./possible-items-list.component.mock.scss', '../possible-items-list.component.scss']
})
export class PossibleItemsListMockComponent {}
